(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/favorites/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/casino/favorites/assets/javascripts/prescript.js'); "use strict";


svs.casino = svs.casino || {};
svs.casino.storedFavorites = svs.casino.storedFavorites || {};
svs.casino.storedFavorites.data = svs.casino.storedFavorites.data || {};
 })(window);